import { SET_CURRENT_STYIST } from 'salon/actions';

const currentStylistReducer = (state = { stylist: null }, action) => {
  if (action && action.type) {
    switch (action.type) {
      case SET_CURRENT_STYIST:
        return {
          ...state,
          stylist: action.stylist,
        };
      default:
        return state;
    }
  }
  return state;
};

export default currentStylistReducer;
